module.exports = __webpack_public_path__ + "img/flow-icon-2.070e19d2.png";